import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../utilities/LogErrors'

import { InstructorBase } from './../../../Layouts/Instructor/V2/InstructorBase'
import { Loading } from './../../../Common/Loading'
import { SupportContent } from './../../../Common/Support/SupportContent'

import { ValidateSession } from './../../../../utilities/BL/Sessions'
import { WEBPAGES } from './../../../../utilities/EL/WebPages'
import { ROLES } from './../../../../utilities/EL/Roles'


// Atención al Líder
// Misma estructura que la página de Atención al Instructor (validación de sesión + InstructorBase,
// que también usan las demás páginas del Líder) con el mismo contenido.

const Support = () => {
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true)

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        async function Validate() {
            try {
                const tmpSession = await ValidateSession()

                if (tmpSession.success) {
                    if (tmpSession.data.user.userStatus === 2) {
                        setIsLoading(false)
                    } else {
                        navigate('/confirm')
                    }
                } else {
                    navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
                }
            } catch (error) {
                await LogErrors('Validate - Leader Support', error)
            }
        }
        Validate()
    }, []) // eslint-disable-line

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <InstructorBase urlToGo={'/dashboard'} page={WEBPAGES.LEADER.SUPPORT} role={ROLES.LEADER}>
                    <SupportContent title='Atención al Líder' />
                </InstructorBase>
            )}
        </>
    )
}

export { Support };
